export const __FARM_GLOBAL__ = {
  __FARM_RESTART_DEV_SERVER__: false
};
